export default "__VITE_ASSET__BU9Ghq$2__"